export default "__VITE_ASSET__8oXO1KAj__"